import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import theme from '@/theme/theme';
import { ThemeProvider } from '@/providers/theme.provider';
import { CustomProvider } from '@/providers/custom.provider';
import { GlobalDataProvider } from '@/providers/global-data.provider';

// Pages
import BlockchainStatsPage from '@/pages/blockchain/Stats';
import BlockchainWalletPage from '@/pages/blockchain/Wallet';
import BlockchainBuyPage from '@/pages/blockchain/Buy';
import BlockchainShowcasePage from '@/pages/blockchain/Showcase';
import BlockchainEcosystemPage from '@/pages/blockchain/Ecosystem';
import BlockchainEmissionPage from '@/pages/blockchain/Emission';
import BlockchainStakingPage from '@/pages/blockchain/Staking';
import BlockchainFarmingPage from '@/pages/blockchain/Farming';
import BlockchainBridgePage from '@/pages/blockchain/Bridge';
import BlockchainBridgeScanPage from '@/pages/blockchain/BridgeScan';
import SiloStatsPage from '@/pages/silo/Stats';
import SiloIndividualPage from '@/pages/silo/Individual';
import SiloEnterprisePage from '@/pages/silo/Enterprise';
import SiloNodesPage from '@/pages/silo/Nodes';
import SiloSetupNodePage from '@/pages/silo/SetupNode';
import SiloRewardCalculatorPage from '@/pages/silo/RewardCalculator';
import LRSNodeStatsPage from '@/pages/lrsnode/Stats';
import LRSNodeMyNodesPage from '@/pages/lrsnode/MyNodes';
import LRSNodeMyNodesV3Page from '@/pages/lrsnode/MyNodesV3';
import LRSNodeRewardCalculatorPage from '@/pages/lrsnode/RewardCalculator';
import BlockchainBridgeStatsPage from '@/pages/blockchain/BridgeStats';
import BlockchainMigrationPage from '@/pages/blockchain/Migration';
import BlockchainMigrationSiloPage from '@/pages/blockchain/MigrationSilo';
import NftV1Page from '@/pages/nfts/V1';
import NftV2Page from '@/pages/nfts/V2';
import MarketplacePage from '@/pages/nfts/Marketplace';
import DonationPage from '@/pages/donation/Donation';
import LarissaDaoPage from '@/pages/larissa-dao/LarissaDao';

function App() {
  return (
    <div
      className="antialiased"
      style={{
        "--larissa-primary": theme.colors.primary.hex,
      } as React.CSSProperties}
    >
      <CustomProvider>
        <ThemeProvider defaultTheme="dark">
          <GlobalDataProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Navigate to="/blockchain/stats" replace />} />
                <Route path="/blockchain" element={<Navigate to="/blockchain/stats" replace />} />
                <Route path="/blockchain/stats" element={<BlockchainStatsPage />} />
                <Route path="/blockchain/wallet" element={<BlockchainWalletPage />} />
                <Route path="/blockchain/buy" element={<BlockchainBuyPage />} />
                <Route path="/blockchain/showcase" element={<BlockchainShowcasePage />} />
                <Route path="/blockchain/ecosystem" element={<BlockchainEcosystemPage />} />
                <Route path="/blockchain/emission" element={<BlockchainEmissionPage />} />
                <Route path="/blockchain/staking" element={<BlockchainStakingPage />} />
                <Route path="/blockchain/farming" element={<BlockchainFarmingPage />} />
                <Route path="/blockchain/bridge" element={<BlockchainBridgePage />} />
                <Route path="/blockchain/bridge-scan" element={<BlockchainBridgeScanPage />} />
                <Route path="/blockchain/bridge-stats" element={<BlockchainBridgeStatsPage />} />
                <Route path="/blockchain/migration/lrsn" element={<BlockchainMigrationPage />} />
                <Route path="/blockchain/migration/silo" element={<BlockchainMigrationSiloPage />} />
                <Route path="/silo" element={<Navigate to="/silo/nodes" replace />} />
                <Route path="/silo/stats" element={<SiloStatsPage />} />
                <Route path="/silo/individual" element={<SiloIndividualPage />} />
                <Route path="/silo/enterprise" element={<SiloEnterprisePage />} />
                <Route path="/silo/nodes" element={<SiloNodesPage />} />
                <Route path="/silo/setup-node" element={<SiloSetupNodePage />} />
                <Route path="/silo/reward-calculator" element={<SiloRewardCalculatorPage />} />
                <Route path="/lrsnode" element={<Navigate to="/lrsnode/mynodes-v3" replace />} />
                <Route path="/lrsnode/stats" element={<LRSNodeStatsPage />} />
                <Route path="/lrsnode/mynodes" element={<LRSNodeMyNodesPage />} />
                <Route path="/lrsnode/mynodes-v3" element={<LRSNodeMyNodesV3Page />} />
                <Route path="/lrsnode/reward-calculator" element={<LRSNodeRewardCalculatorPage />} />
                <Route path="/nfts" element={<Navigate to="/nfts/v1" replace />} />
                <Route path="/nfts/v1" element={<NftV1Page />} />
                <Route path="/nfts/v2" element={<NftV2Page />} />
                <Route path="/nfts/marketplace" element={<MarketplacePage />} />
                <Route path="/donation" element={<DonationPage />} />
                <Route path="/larissa-dao" element={<LarissaDaoPage />} />
              </Routes>
            </BrowserRouter>
          </GlobalDataProvider>
        </ThemeProvider>
      </CustomProvider>
    </div>
  );
}

export default App;

